import React from 'react';
import WName from '../../../../WName';
import PL from '../../../../problems/ProblemLink';
import QL from '../../../../faq/QuestionLink';
import AL from '../../../../angles/AngleLink';
import NW from '../../../../neologisms/NewWord';
import OML from '../../../../ormaybe/OrMaybeLink';
import LRL from '../../../LongReadLink';
import {E1, E2, Qual} from '../../../../common';

// ‘’ … –

// mathematical induction
export const induction = {
  name: "induction",
  header: <span>
    Apparently this falsifies mathematical induction at infinity.
  </span>,
  preview: <div className="long-read-preview">
    <p>Mathematical induction works like this:</p>
    <ul>
      <li>Prove that P(0) holds.</li>
      <li>Prove that P(<i>n</i>) ⇒ P(<i>n</i> + 1).</li>
      <li>Then P(<i>n</i>) holds for <i>all</i> <i>n</i>.</li>
      <li> </li>
<p>so if <i>n</i> ∈ ጨ…</p>
    </ul>
  </div>,
//  text: <div className="long-read-text">
//  </div>,
};
